<template>
  <div
    class="modal fade"
    id="shopperFilterModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.CSM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <ShopperFilter
            ref="shopperFilterComponent"
            :currentFilterObject="filterObject"
            :locationPropertiesList="locationPropertiesList"
            :countryList="countryList"
            :regionList="regionList"
            @filterUpdate="filterObject = $event"
          ></ShopperFilter>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised pull-left"
            @click="copyFilter()"
          >
            {{ lang.CSM004 }}
          </button>
          <button
            type="button"
            class="btn btn-raised pull-left"
            :disabled="
              !copyData.filterObject || copyData.client !== selectedClient
            "
            @click="restoreFilter()"
          >
            {{ lang.CSM005 }}
          </button>
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.CSM001 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopperFilter from "../Recruiting/ShopperFilter";

export default {
  name: "ShopperFilterModal",
  components: {
    ShopperFilter,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    selectedClient: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterObject: {},
      countryList: [],
      regionList: [],
      locationPropertiesList: [],
      copyData: {},
      lang: {
        CSM000: "Shopper Filter",
        CSM001: "Close",
        CSM002: "Location property data request failed",
        CSM003: "Please set client filter first",
        CSM004: "Copy filter",
        CSM005: "Paste filter",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    selectedClient() {
      this.locationPropertiesList = [];
      if (this.filterObject.NotWithLocationPropertyGuids)
        delete this.filterObject.NotWithLocationPropertyGuids;
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
      this.globals.getRegionsList((callbackData) => {
        this.regionList = callbackData;
      });
    },
  },
  created() {
    this.globals.getCountryList(this.convertCountryList);
    this.globals.getRegionsList((callbackData) => {
      this.regionList = callbackData;
    });
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#shopperFilterModal").on("hidden.bs.modal", (e) => {
      this.$refs.shopperFilterComponent.collectFilterData();
      this.globals.$emit("getDataFromShopperFilterModal", this.filterObject);
      this.$emit("modalClosed");
    });

    this.globals.$off("sendDataToShopperFilterModal");
    this.globals.$on("sendDataToShopperFilterModal", (data) => {
      this.filterObject = data ? _.cloneDeep(data) : {};
      this.$nextTick(() => {
        this.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    });
  },
  methods: {
    openModal() {
      if (!this.selectedClient) {
        console.error("No client selected");
        this.globals.showErrorSnackbar(this.lang.CSM003);
        this.$emit("modalClosed");
        return;
      }
      this.getLocationProperties();
      $("#shopperFilterModal").modal("show");
    },
    closeModal() {
      $("#shopperFilterModal").modal("hide");
    },
    copyFilter() {
      this.$refs.shopperFilterComponent.collectFilterData();
      this.copyData = {
        filterObject: _.cloneDeep(this.filterObject),
        client: this.selectedClient,
      };
    },
    restoreFilter() {
      if (
        !this.copyData.client ||
        this.copyData.client !== this.selectedClient ||
        !this.copyData.filterObject
      )
        return;
      this.filterObject = this.copyData.filterObject;
      this.$nextTick(() => {
        this.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    },
    convertCountryList(data) {
      this.countryList = [];
      for (let country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country],
        });
      }
    },
    getLocationProperties() {
      if (this.locationPropertiesList.length > 0) return;

      let query = `api/Recruiting/Data/LocationProperties/${this.selectedClient}`;
      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          this.locationPropertiesList = data;
        },
        error: () => {
          console.error("Error on GET in getLocationProperties()");
          this.globals.showErrorSnackbar(this.lang.CSM002);
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-footer > .btn.pull-left {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// ShopperFilterModal.vue?0bf69579